'use client'

import { useCallback, useLayoutEffect } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

const RETRY_INTERVAL_MS = 300

const useLoadConsentBanner = (abVariant?: string) => {
  const translate = useTranslate('consent_banner')

  const applyAbTestStyles = useCallback(() => {
    const policyTitle = document.getElementById('onetrust-policy-title')
    const vendorCount = Number(document.querySelector('.ot-tcf2-vendor-count')?.innerHTML)
    const policyText = document.getElementById('onetrust-policy-text')
    const dpdTitle = document.querySelector('.ot-dpd-title')
    const dpdDesc = document.querySelector('.ot-dpd-desc')

    const isAbTestRunning = abVariant === 'a' || abVariant === 'b'

    if (isAbTestRunning && policyTitle && policyText && vendorCount && dpdTitle && dpdDesc) {
      policyTitle.innerHTML = translate(`policy_title_${abVariant}`)

      dpdTitle.innerHTML = `<h3 class="ot-dpd-title-test">${translate(`policy_dpd_title_${abVariant}`)}</h3>`

      policyText.innerHTML = `
        <p>${translate(
          `policy_text_headline_${abVariant}`,
          { number_partners: vendorCount },
          { count: vendorCount },
        )}</p>
        <br />
        <p>${translate(`policy_text_subheadline_${abVariant}`)}</p>
        <br/>
      `

      dpdDesc.innerHTML = `
        <ul class="ot-dpd-list-test">
          <li>${translate(`policy_dpd_content_${abVariant}.personalised_ads`)}</li>
          <li>${translate(`policy_dpd_content_${abVariant}.content_profile`)}</li>
          <li>${translate(`policy_dpd_content_${abVariant}.performance`)}</li>
        </ul>
        <div>
          <a class="ot-cookie-policy-link" rel="noopener" target="_blank" href="/privacy-policy">
            ${translate(`policy_link_${abVariant}`)}
          </a>
          <span class="ot-dpd-list-bullet-test">&#8226;</span>
          <button class="ot-link-btn onetrust-vendors-list-handler">
            ${translate(`vendor_link_${abVariant}`)}
          </button>
        </div>
      `
    }
  }, [abVariant, translate])

  useLayoutEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null

    const clearExistingTimeout = () => {
      if (!timeoutId) return

      clearTimeout(timeoutId)
      timeoutId = null
    }

    const applyBannerClass = () => {
      const onetrustBanner = document.getElementById('onetrust-banner-sdk')

      if (!onetrustBanner) {
        timeoutId = setTimeout(applyBannerClass, RETRY_INTERVAL_MS)

        return
      }

      applyAbTestStyles()

      onetrustBanner.classList.add('onetrust-banner-sdk--loaded')

      clearExistingTimeout()
    }

    applyBannerClass()

    return clearExistingTimeout
  }, [applyAbTestStyles])
}

export default useLoadConsentBanner
